import qs from "qs";
import fetch from "../../lib/fetch";

export const CONTEXTPATH = (window.CONTEXTPATH = window.CONTEXTPATH || "/process");

export const xService = async param => {
  return await fetch(
    `/path/to/service.do`,
    qs.stringify(
      param
    ) /*, config => (config.headers['Content-Type'] = 'application/json; chartset=UTF-8', config)*/
  );
  // 可以自定义修改axios实例
};


export const addAdmin = async param => {
  return await fetch(`${CONTEXTPATH}/addAdmin`, param);
};

export const addBook = async param => {
  return await fetch(`${CONTEXTPATH}/addBook`, param);
};

export const deleteById = async param => {
  return await fetch(`${CONTEXTPATH}/deleteById`, param);
};

// 查询邀请码
export const queryInviteCode = async param => {
  return await fetch(`${CONTEXTPATH}/queryInviteCode`, param);
};

export const login = async param => {
  return await fetch(`${CONTEXTPATH}/login`, param);
};

export const register = async param => {
  return await fetch(`${CONTEXTPATH}/register`, param);
};

export const getDataList = async param => {
  return await fetch(`${CONTEXTPATH}/search`, param);
};
// 图书列表接口
export const getBookList = async param => {
  return await fetch(`${CONTEXTPATH}/searchBook`, param);
};
// 报表中心接口
export const queryReportCenterList = async param => {
  return await fetch(`${CONTEXTPATH}/queryReportCenterList`, param);
};
// 收发货报表
export const queryExitAndReceive = async param => {
  return await fetch(`${CONTEXTPATH}/queryExitAndReceive`, param);
};
// 司机管理
export const queryDriver = async param => {
  return await fetch(`${CONTEXTPATH}/queryDriver`, param);
};
// 查询安卓下载链接
export const queryAndriodLink = async param => {
  return await fetch(`${CONTEXTPATH}/queryAndriodLink`, param);
};
// 司机管理新增
export const addDriver = async param => {
  return await fetch(`${CONTEXTPATH}/addDriver`, param);
};
// 司机管理删除
export const deleteDriverById = async param => {
  return await fetch(`${CONTEXTPATH}/deleteDriverById`, param);
};



// WEBPACK FOOTER //
// ./src/service/index.js